import GoogleTagManager from '../../../../js/thirdparty/analytics/GoogleTagManager';
import Utils from '../../../../js/helpers/Utils';

// Payload required: { event: value, path: value, title: value}
const trackClickEvent = (context, payload) => {
    GoogleTagManager.trackClickEvent(payload.event, payload.path, payload.title);
    if(!Utils.isEmpty(payload.url)){
        top.window.location.href = payload.url;
    }
}

// Payload required: { event: value, path: value, title: value, url: value}
const trackOutboundClickEvent = (context, payload) => {
    GoogleTagManager.trackOutboundClickEvent(payload.event, payload.path, payload.title, payload.url);
    if(!Utils.isEmpty(payload.url)){
        top.window.open(payload.url);
    }
}

// Payload required: { event: value, data: {currency: value, items: value} }
const triggerActionEvent = (context, payload) => {
    GoogleTagManager.triggerActionEvent(payload.event, payload.data);
}

export {
    trackClickEvent,
    trackOutboundClickEvent,
    triggerActionEvent
}
